import React, {useCallback, useEffect, useState} from 'react';
import {Redirect} from 'react-router-dom';
import clsx from 'clsx';
import {makeStyles} from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import {Box, CircularProgress, List, ListItem, ListItemIcon, ListItemText,} from '@material-ui/core';
import {ExitToApp as ExitToAppIcon, Home as HomeIcon, People as PeopleIcon,} from '@material-ui/icons'
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Avatar from '@material-ui/core/Avatar';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import Iframe from 'react-iframe'
import {AuthContext} from './context';
import GLOBAL from "../globales";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
    },
    drawerPaper: {
        justifyContent: 'space-between',
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 750,
    },
    large: {
        width: theme.spacing(7),
        height: theme.spacing(7),
        borderRadius: 0
    }
}));

export default function Dashboard() {
    const classes = useStyles();

    const [open, setOpen] = React.useState(false);

    const toggleDrawer = () => {
        setOpen((prev) => !prev);
    };

    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);

    const [data, setData] = useState({
        userEmail: null,
        userToken: null,
        isLoading: true,
    });

    const [frame, setFrame] = useState(null);

    const {signOut} = React.useContext(AuthContext);

    const cerrarSesion = () => {
        try {
            signOut();
            setData({
                ...data,
                userToken: null,
                userEmail: null,
            });
            return true;
        } catch (e) {
            console.log(e);
            return false;
        }
    }

    const updateLogin = useCallback(() => {
        let _userToken = null;
        let _userEmail = null;
        let _sameToken = null;
        let _sameEmail = null;
        try {
            _userToken = localStorage.getItem("userToken");
            _userEmail = localStorage.getItem("userEmail");
            _sameToken = (_userToken === data.userToken);
            _sameEmail = (_userEmail === data.userEmail);
            if (!(_userToken && _userEmail && _sameToken && _sameEmail)) {
                setData({
                    ...data,
                    userToken: _userToken,
                    userEmail: _userEmail,
                    isLoading: false,
                });
            }
            return true;
        } catch (e) {
            console.log(e);
            return false;
        }
    }, [data]);

    useEffect(() => {
        updateLogin();
        setFrame('inicio');
    }, [updateLogin]);

    let mainContent = null;
    let mainContentProps = {
        width: '100%',
        height: '750px',
        display: 'initial',
        position: 'relative',
        frameBorder: 0
    }

    if (data.isLoading) {
        return (
            <Box display={'flex'} justifyContent={'center'} alignItems={'center'} minHeight={'50vh'}>
                <CircularProgress size={'10rem'}/>
            </Box>
        );
    } else {
        if (data.userToken === null || data.userEmail === null) {
            mainContent = (
                <Redirect to={'/'}/>
            );
        } else {
            let urlQuery = '';
            switch (frame) {
                case 'inicio':
                    urlQuery = "?user_action=inicio&user_email=" + data.userEmail + "&user_token=" + String(data.userToken);
                    mainContent = (
                        <Iframe url={GLOBAL.URL_APP + urlQuery} {...mainContentProps}/>
                    );
                    break;
                case 'creditos':
                    urlQuery = "?user_action=creditos&user_email=" + data.userEmail + "&user_token=" + String(data.userToken);
                    mainContent = (
                        <Iframe url={GLOBAL.URL_APP + urlQuery} {...mainContentProps}/>
                    );
                    break;
                default:
                    mainContent = (
                        <></>
                    );
            }
        }
    }

    return (
        <div className={classes.root}>
            <CssBaseline/>
            <AppBar position="absolute" color="default" className={clsx(classes.appBar, open && classes.appBarShift)}>
                <Toolbar className={classes.toolbar}>
                    <IconButton
                        edge="start"
                        color="inherit"
                        aria-label="open drawer"
                        onClick={toggleDrawer}
                        className={clsx(classes.menuButton, open && classes.menuButtonHidden)}
                    >
                        <MenuIcon/>
                    </IconButton>
                    <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>
                        Culturas Andinas
                    </Typography>
                    <IconButton color="inherit">
                        <Avatar src="https://uads.unap.cl/conadi/archivos/imagenes/logo_app_v3.png"
                                className={classes.large}/>
                    </IconButton>
                </Toolbar>
            </AppBar>
            <Drawer classes={{paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),}}
                    open={open}>
                <List>
                    <Container className={classes.toolbarIcon}>
                        <IconButton onClick={toggleDrawer}>
                            <ChevronLeftIcon/>
                        </IconButton>
                    </Container>
                    <Divider/>
                    <ListItem button onClick={() => {
                        updateLogin() && (setFrame('inicio') || toggleDrawer())
                    }}>
                        <ListItemIcon>
                            <HomeIcon/>
                        </ListItemIcon>
                        <ListItemText primary="Inicio"/>
                    </ListItem>
                    <ListItem button onClick={() => {
                        updateLogin() && (setFrame('creditos') || toggleDrawer())
                    }}>
                        <ListItemIcon>
                            <PeopleIcon/>
                        </ListItemIcon>
                        <ListItemText primary="Créditos"/>
                    </ListItem>
                </List>
                <List>
                    <Divider/>
                    <ListItem>
                        <Paper elevation={0}>
                            <img src={process.env.PUBLIC_URL + "/img/conadi.png"}
                                 style={{width: '150px'}} alt='Logo CONADI'/>
                        </Paper>
                    </ListItem>
                    <ListItem button onClick={cerrarSesion}>
                        <ListItemIcon>
                            <ExitToAppIcon/>
                        </ListItemIcon>
                        <ListItemText primary="Cerrar sesión"/>
                    </ListItem>
                </List>
            </Drawer>
            <main className={classes.content}>
                <div className={classes.appBarSpacer}/>
                <Container maxWidth="lg" className={classes.container}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={12} lg={12}>
                            <Paper className={fixedHeightPaper}>
                                {mainContent}
                            </Paper>
                        </Grid>

                    </Grid>
                </Container>
            </main>
        </div>
    );
}